import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import ReactWhatsapp from 'react-whatsapp';
import { BASE_URLS } from '../config/globalConfig';

export default function CourseCards() {
    const location = useLocation();
    
    // Get dynamic descriptions based on route
    const getCourseDescriptions = () => {
        const pathname = location.pathname;
        
        // Routes that don't show crash course
        const noCrashCourseRoutes = ['/music-production', '/dual-program', '/all-in-one'];
        const shouldShowCrashCourse = !noCrashCourseRoutes.includes(pathname);
        
        let quarterDescription = '';
        let certificationDescription = '';
        let quarterSessions = '';
        let certificationSessions = '';
        
        if (pathname === '/music-production') {
            quarterDescription = "This program consists of 36 sessions that take you from the basics to advanced levels with a strong focus on genre-based studies. It is ideal for learners who want to study seriously, build solid foundations, and begin their journey as professional music arrangers and recording artists, while also learning essential recording techniques. The course includes attractive discounts and full access to all progress-tracking tools on the student dashboard.";
            certificationDescription = "Our most comprehensive program, featuring 72 sessions, includes everything offered in the Quarter Course—plus advanced training in recording, mixing, mastering, and an introduction to studio acoustics. Perfect for students seeking long-term, in-depth training to develop professional-level skills as complete music producers. This course also offers the maximum discounts and full access to every progress-tracking feature on the student dashboard.";
            quarterSessions = '36 Sessions - 3 to 6 Months';
            certificationSessions = '72 Sessions - 6 Months to 1 year';
        } else if (pathname === '/dual-program') {
            quarterDescription = "Perfect for learners who want to study two instruments or voice disciplines simultaneously while building strong foundations.\nClass Division:\n24 Sessions – Subject 1\n24 Sessions – Subject 2\nThis program offers greater savings compared to enrolling separately for two different subjects and includes full access to all progress-tracking tools on the student dashboard — helping you reach your goals faster.";
            certificationDescription = "Our most comprehensive and value-packed program, designed for students who wish to pursue two instruments or voice disciplines at once with long-term, in-depth training to achieve professional-level skills in both subjects.\nClass Division:\n48 Sessions – Subject 1\n48 Sessions – Subject 2\nThis course provides the maximum discounts for dual enrollment along with full access to every progress-tracking feature on the student dashboard — enabling you to achieve your goals faster and with ease.";
            quarterSessions = '48 Sessions - 3 to 6 Months';
            certificationSessions = '96 Sessions - 6 Months to 1 year';
        } else if (pathname === '/all-in-one') {
            quarterDescription = "Perfect for learners who want to study three instruments or voice disciplines at the same time while building strong foundations.\nClass Division:\n24 Sessions – Subject 1\n24 Sessions – Subject 2\n24 Sessions – Subject 3\nTotal Sessions: 72\nThis program offers significant savings compared to enrolling separately for three subjects. It also includes full access to all progress-tracking tools on the student dashboard — helping you reach your goals faster.";
            certificationDescription = "Our most comprehensive and value-packed program, created for students who want to pursue three instruments or voice disciplines at once with long-term, in-depth training to achieve professional-level skills in all three areas.\nClass Division:\n48 Sessions – Subject 1\n48 Sessions – Subject 2\n48 Sessions – Subject 3\nTotal Sessions: 144\nThis course provides the maximum discounts for three-subject enrollment, along with full access to every progress-tracking feature on the student dashboard — enabling you to achieve your goals faster and with ease.";
            quarterSessions = '72 Sessions - 3 to 6 Months';
            certificationSessions = '144 Sessions - 6 Months to 1 year';
        } else {
            // Default descriptions for other course pages
            quarterDescription = "Best suited for learners who wish to study more seriously and build strong foundations. Comes with attractive discounts and full access to all progress tracking tools on the student dashboard.";
            certificationDescription = "Our most comprehensive and value-packed option. Designed for students who want long-term, in-depth training to achieve professional-level skills. Offers the maximum discounts and full access to every progress tracking feature on the student dashboard.";
            quarterSessions = '24 Sessions - 3 to 6 months';
            certificationSessions = '48 Sessions - 6 months to 1 year';
        }
        
        return {
            shouldShowCrashCourse,
            quarterDescription,
            certificationDescription,
            quarterSessions,
            certificationSessions
        };
    };

    const { shouldShowCrashCourse, quarterDescription, certificationDescription, quarterSessions, certificationSessions } = getCourseDescriptions();
    const [activeTab, setActiveTab] = useState(shouldShowCrashCourse ? 'crash' : 'quarter');

    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
    };

    return (
        <>
            <section id="our-courses-section">
                <div className="our-courses-container">
                    <div className="our-courses-header">
                        <h2 className="section-title">Our Courses</h2>
                        <p className="section-subtitle">Choose the perfect course plan for your guitar learning journey</p>
                    </div>

                    <div className="course-tabs">
                        <div className="tab-buttons">
                            <div className="tab-main">
                                {shouldShowCrashCourse && (
                                    <div>
                                        <button
                                            className={`tab-button ${activeTab === 'crash' ? 'active' : ''}`}
                                            data-tab="crash"
                                            onClick={() => handleTabClick('crash')}
                                        >
                                            <div className="tab-icon">
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                                                </svg>
                                            </div>
                                            <span>CRASH COURSE</span>
                                        </button>

                                        <div className="course-related-description" 
                                        style={{ 
                                            display: activeTab === 'crash' ? 'block' : 'none',
                                            marginTop: '15px'
                                        }}>
                                            <p>Perfect for beginners or those looking for a short-term experience. Ideal as a vacation activity or a first-time trial of an instrument or vocal style. Includes partial access to the student dashboard's progress tracking features.</p>
                                        </div>
                                    </div>
                                )}

                                <div>
                                    <button
                                        className={`tab-button ${activeTab === 'quarter' ? 'active' : ''}`}
                                        data-tab="quarter"
                                        onClick={() => handleTabClick('quarter')}
                                    >
                                        <div className="tab-icon">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                            </svg>
                                        </div>
                                        <span>quarter COURSE</span>
                                    </button>

                                    <div className="course-related-description" 
                                    style={{ 
                                        display: activeTab === 'quarter' ? 'block' : 'none',
                                        marginTop: '15px'
                                    }}>
                                        <p style={{ whiteSpace: 'pre-line' }}>{quarterDescription}</p>
                                    </div>
                                </div>

                                <div>
                                    <button
                                        className={`tab-button ${activeTab === 'certification' ? 'active' : ''}`}
                                        data-tab="certification"
                                        onClick={() => handleTabClick('certification')}
                                    >
                                        <div className="tab-icon">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" transform="translate(0, 2)" />
                                            </svg>
                                        </div>
                                        <span>certification COURSE</span>
                                    </button>
                                
                                    <div className="course-related-description" 
                                    style={{ 
                                        display: activeTab === 'certification' ? 'block' : 'none',
                                        marginTop: '15px'
                                    }}>
                                        <p style={{ whiteSpace: 'pre-line' }}>{certificationDescription}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="main-download">
                                <ReactWhatsapp
                                    number={BASE_URLS.CONTACT.WHATSAPP}
                                    message="Hello! I would like to request the HSM course brochure. Please send me the detailed information about your music courses. Thank you!"
                                    element="button"
                                    className="tab-button"
                                >
                                    <div className="tab-icon">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                                        </svg>
                                    </div>
                                    <span>REQUEST BROCHURE</span>
                                </ReactWhatsapp>
                            </div>
                        </div>

                        <div className="tab-content">
                            {shouldShowCrashCourse && (
                                <div className={`course-plan-card ${activeTab === 'crash' ? 'active' : ''}`} data-tab="crash">
                                <div className="course-plan-icon">
                                    <div className="icon-circle">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                                        </svg>
                                    </div>
                                </div>

                                <h3 className="course-plan-title">CRASH COURSE</h3>
                                <div className="course-plan-duration">10 Session - 5 to 10 Weeks</div>

                                <div className="course-plan-features">
                                    <div className="feature-item">
                                        <span className="feature-label">Class Duration:</span>
                                        <span className="feature-value">60 Minutes</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Class Format:</span>
                                        <span className="feature-value">Online, Solo 1-1</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Extra Study Materials:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Daily Class Update:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Access to Class Recordings:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">24X7 Chat Support:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Personalised Curriculum:</span>
                                        <span className="feature-value">❌</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Daily Assignments:</span>
                                        <span className="feature-value">❌</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Progress Reports:</span>
                                        <span className="feature-value">❌</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Tests:</span>
                                        <span className="feature-value">❌</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Certification:</span>
                                        <span className="feature-value">❌</span>
                                    </div>
                                </div>
                            </div>
                            )}

                            <div className={`course-plan-card ${activeTab === 'quarter' ? 'active' : ''}`} data-tab="quarter">
                                <div className="course-plan-icon">
                                    <div className="icon-circle">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                        </svg>
                                    </div>
                                </div>

                                <h3 className="course-plan-title">Quarter Course</h3>
                                <div className="course-plan-duration">{quarterSessions}</div>

                                <div className="course-plan-features">
                                    <div className="feature-item">
                                        <span className="feature-label">Class Duration:</span>
                                        <span className="feature-value">60 Minutes</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Class Format:</span>
                                        <span className="feature-value">Online, Solo 1-1</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Extra Study Materials:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Daily Class Update:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Access to Class Recordings:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">24X7 Chat Support:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Personalised Curriculum:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Daily Assignments:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Progress Reports:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Tests:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Certification:</span>
                                        <span className="feature-value">❌</span>
                                    </div>
                                </div>
                            </div>

                            <div className={`course-plan-card ${activeTab === 'certification' ? 'active' : ''}`} data-tab="certification">
                                <div className="course-plan-icon">
                                    <div className="icon-circle">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                        </svg>
                                    </div>
                                </div>

                                <h3 className="course-plan-title">Certification Course</h3>
                                <div className="course-plan-duration">{certificationSessions}</div>

                                <div className="course-plan-features">
                                    <div className="feature-item">
                                        <span className="feature-label">Class Duration:</span>
                                        <span className="feature-value">60 Minutes</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Class Format:</span>
                                        <span className="feature-value">Online, Solo 1-1</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Extra Study Materials:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Daily Class Update:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Access to Class Recordings:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">24X7 Chat Support:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Personalised Curriculum:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Daily Assignments:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Progress Reports:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Tests:</span>
                                        <span className="feature-value">✅</span>
                                    </div>

                                    <div className="feature-item">
                                        <span className="feature-label">Certification:</span>
                                        <span className="feature-value">✅</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
} 